import { render } from "./UserReward.vue?vue&type=template&id=f41c281a&scoped=true"
import script from "./UserReward.vue?vue&type=script&lang=js"
export * from "./UserReward.vue?vue&type=script&lang=js"

import "./UserReward.vue?vue&type=style&index=0&id=f41c281a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f41c281a"]])

export default __exports__